"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * OpenStax Open-Search API
 * A search engine for OpenStax open content.  Requests to this API should include `application/json` in the `Accept` header.  The desired API version is specified in the request URL, e.g. `[domain]/open-search/api/v0/search`.While the API does support a default version, that version will change overtime and therefore should not be used in production code!
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultApi = void 0;
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class DefaultApi extends runtime.BaseAPI {
    /**
     * Get info on indexes
     * Get info on indexes
     */
    esInfoRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/es-info`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.EsInfoResultsFromJSON(jsonValue));
        });
    }
    /**
     * Get info on indexes
     * Get info on indexes
     */
    esInfo() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.esInfoRaw();
            return yield response.value();
        });
    }
    /**
     * Get info on indexes
     * Get info on indexes
     */
    infoRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/info`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.InfoResultsFromJSON(jsonValue));
        });
    }
    /**
     * Get info on indexes
     * Get info on indexes
     */
    info() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.infoRaw();
            return yield response.value();
        });
    }
}
exports.DefaultApi = DefaultApi;
